import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const groups = [
  {
    title: "Private Feiern",
    description:
      "Hochzeiten, Geburtstage, Jubiläen – Ihr Fest in historischem Ambiente mit 302 Jahren Geschichte.",
    image:
      "https://images.unsplash.com/photo-1736238952214-88853aa68b2b?auto=format&fit=crop&w=800&q=80",
    badge: "Hochzeit · Geburtstag · Jubiläum",
  },
  {
    title: "Firmenevents",
    description:
      "Produktpräsentationen, Betriebsfeste, Tagungen – authentisches Ambiente für außergewöhnliche Events.",
    image:
      "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=800&q=80",
    badge: "Businessevent · Tagung · Messe",
  },
  {
    title: "Kunstveranstaltungen",
    description:
      "Konzerte, Ausstellungen, Theater – Klaus Teichmanns Künstlerhof als einzigartige Bühne im Ruhrgebiet.",
    image:
      "https://images.unsplash.com/photo-1779300007516-eebee9151c19?auto=format&fit=crop&w=800&q=80",
    badge: "Konzert · Ausstellung · Film",
  },
];

export default function TargetGroups() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-12" data-testid="target-groups">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p
            className="text-[#C1440E] text-xs tracking-[0.4em] uppercase mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Für alle Anlässe
          </p>
          <h2
            className="text-4xl md:text-5xl font-light text-[#F2EDE8]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Drei Zielgruppen. Eine Location.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5">
          {groups.map((group, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="group relative overflow-hidden cursor-pointer"
              style={{ aspectRatio: "3/4" }}
              data-testid={`target-group-card-${i}`}
            >
              <img
                src={group.image}
                alt={group.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-[#141414]/60 to-[#141414]/10" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <p
                  className="text-[#D4A843] text-[10px] tracking-[0.3em] uppercase mb-2"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {group.badge}
                </p>
                <h3
                  className="text-2xl md:text-3xl font-extrabold text-[#F2EDE8] uppercase mb-3"
                  style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                >
                  {group.title}
                </h3>
                <p
                  className="text-[#F2EDE8]/55 text-sm leading-relaxed mb-5"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {group.description}
                </p>
                <Link
                  to="/kontakt"
                  className="flex items-center gap-2 text-[#C1440E] group-hover:text-[#D4A843] text-xs tracking-[0.2em] uppercase transition-colors duration-200"
                  data-testid={`target-group-link-${i}`}
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  Anfragen <ArrowRight size={13} />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
